/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {CouponListPageComponent} from './coupon-list-page.component';

@Component({
  standalone: true,
  imports: [CouponListPageComponent],
  selector: 'adn-coupon-route-page',
  template: `
    <adn-coupon-list-page [readOnly]="readOnly"></adn-coupon-list-page>
  `
})
export class CouponRoutePageComponent {
  @Input() readOnly = false;
}
